// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__tw96O","normal":"Index_normal__2JBUR","normalh5":"Index_normalh5__1Fy0a","animationFade":"Index_animationFade__1TU5W"};